<template>
  <b-container>
    <b-form
      ref="uploadForm"
      class="mt-5"
      @submit.prevent="onSubmit"
    >
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="タイトル"
            label-for="title"
          >
            <b-form-input
              id="title"
              name="title"
              :value="title"
              type="text"
              required
              placeholder="イベント名を記入してください"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="詳細"
            label-for="description"
          >
            <b-form-textarea
              id="description"
              name="description"
              :value="description"
              type="text"
              required
              placeholder="イベントの詳細情報を記入してください"
              rows="6"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="3"
        >
          <b-form-group
            label="開催日"
            label-for="date"
          >
            <b-form-datepicker
              id="date"
              name="date"
              :value="date"
              :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
              class="mb-2"
              required
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          sm="3"
        >
          <b-form-group
            label="開催時間"
            label-for="time"
          >
            <b-form-timepicker
              id="time"
              name="time"
              :value="time"
              locale="en"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group label="開催場所は">
            <b-form-radio-group v-model="addressType">
              <b-form-radio
                name="some-radios"
                value="address"
              >
                地図付きの住所で公開
              </b-form-radio>
              <b-form-radio
                name="some-radios"
                value="location"
              >
                地名のみで公開
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row
        v-if="addressType === 'address'"
        class="justify-content-center"
      >
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <vue-google-autocomplete
              id="map"
              :value="address"
              classname="form-control"
              :country="['jp']"
              types="establishment"
              placeholder="〒180-0003 東京都武蔵野市吉祥寺南町２丁目１１−1"
              required
              @placechanged="getAddressData"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row
        v-if="mapUrl"
        class="justify-content-center"
      >
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <a
              :href="mapUrl"
              target="_blank"
            >{{ mapUrl }}</a>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row
        v-if="addressType === 'location'"
        class="justify-content-center"
      >
        <b-col
          cols="12"
          sm="3"
        >
          <b-form-group
            label-for="prefecture"
          >
            <b-form-select
              v-model="prefecture"
              :options="prefectureOptions"
              placeholder="Select Prefecture"
              required
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          sm="3"
        >
          <b-form-group>
            <b-form-input
              id="location"
              name="location"
              :value="locationFreeText"
              type="text"
              placeholder="例：渋谷"
              required
              @blur="locationFreeText = $event.target.value"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="URL（任意）"
            label-for="event-url"
          >
            <b-form-input
              id="event-url"
              name="url"
              :value="url"
              type="text"
              placeholder="イベントサイトのURLを記入してください"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="コミュニティ"
            label-for="community"
          >
            <b-form-select
              name="community"
              :value="community"
              :options="communityOptions"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="画像"
            label-for="cropper"
          >
            <cropper
              ref="cropper"
              class="cropper"
              :src="media"
              @ready="cropperReady"
            />
            <b-button
              block
              variant="success"
              class="upload-btn"
            >
              <b-form-file
                ref="file"
                name="media"
                @change="loadImage($event)"
              />
              画像をアップロードしてください
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="タグ（５つまで）"
            label-for="tags"
          >
            <multiselect
              v-model="selectedTags"
              :options="tagOptions"
              label="title"
              :multiple="true"
              track-by="id"
              :max="5"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="justify-content-center mt-5">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <b-button
              type="button"
              block
              variant="primary"
              size="lg"
              :disabled="eventStatus === 'loading'"
              @click="submitForm(null)"
            >
              <b-icon
                v-if="eventStatus === 'loading'"
                icon="three-dots"
                animation="cylon"
                font-scale="1"
              />
              <span v-else>下書きとして保存する</span>
            </b-button>
          </b-form-group>
        </b-col>

        <b-col
          v-if="!published"
          cols="12"
          sm="6"
        >
          <b-form-group>
            <b-button
              type="button"
              block
              variant="success"
              size="lg"
              :disabled="eventStatus === 'loading'"
              @click="submitForm(true)"
            >
              <b-icon
                v-if="eventStatus === 'loading'"
                icon="three-dots"
                animation="cylon"
                font-scale="1"
              />
              <span v-else>保存して公開する</span>
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  COMMUNITY_REQUEST, EVENT_DETAIL, EVENT_EDIT, SET_EVENT_DETAIL,
  TAG_REQUEST, UPDATE_EVENT_PICTURE, UPDATE_EVENT_TAGS
} from '@/store/constant';
import { getImage, getPrefectures } from '@/helpers';
import event from '@/components/mixins/event';

export default {
  name: 'EventEdit',
  mixins: [event],
  data() {
    return {
      isPublish: false,
    }
  },
  computed: {
    title: {
      get() {
        return this.eventDetail ?this.eventDetail.title :null;
      }
    },
    description: {
      get() {
        return this.eventDetail ?this.eventDetail.description :null;
      }
    },
    date: {
      get() {
        return this.eventDetail ?this.eventDetail.date :null;
      }
    },
    time: {
      get() {
        const d = new Date(this.date);
        return this.eventDetail ?`${d.getHours()}:${d.getMinutes()}` :null;
      }
    },
    url: {
      get() {
        return this.eventDetail ?this.eventDetail.url :null;
      }
    },
    published: {
      get() {
        return this.eventDetail ?this.eventDetail.published :null
      },
      set(val) {
        const event = {...this.eventDetail};
        event.published = val;
        this.$store.commit(SET_EVENT_DETAIL, event);
      },
    },
    mapUrl: {
      get() {
        return this.eventDetail ?this.eventDetail.mapUrl :null;
      },
      set(val) {
        const event = {...this.eventDetail};
        event.mapUrl = val;
        this.$store.commit(SET_EVENT_DETAIL, event);
      },
    },
    address: {
      get() {
        return this.eventDetail ?this.eventDetail.address :null;
      },
      set(val) {
        const event = {...this.eventDetail};
        event.address = val;
        this.$store.commit(SET_EVENT_DETAIL, event);
      },
    },
    locationFreeText: {
      get() {
        return this.eventDetail ?this.eventDetail.locationFreeText :null;
      },
      set(val) {
        const event = {...this.eventDetail};
        event.locationFreeText = val;
        this.$store.commit(SET_EVENT_DETAIL, event);
      },
    },
    prefecture: {
      get() {
        return this.eventDetail ?this.eventDetail.prefecture :null;
      },
      set(val) {
        const event = {...this.eventDetail};
        event.prefecture = val;
        this.$store.commit(SET_EVENT_DETAIL, event);
      }
    },
    cityFromPostalCode: {
      get() {
        return this.eventDetail ?this.eventDetail.cityFromPostalCode :null;
      },
      set(val) {
        const event = {...this.eventDetail};
        event.cityFromPostalCode = val;
        this.$store.commit(SET_EVENT_DETAIL, event);
      }
    },
    prefectureOptions: {
      get() {
        const prefectures = getPrefectures();
        let options = [{ value: null, text: 'Please select an option' }];
        for (const item of prefectures) {
          options.push({ value: item, text: item });
        }
        return options;
      }
    },
    community: {
      get() {
        return this.eventDetail && this.eventDetail.community ?this.eventDetail.community.id :null;
      }
    },
    media: {
      get: function () {
        if (this.eventDetail) {
          if (typeof this.eventDetail.media === 'string') {
            return this.eventDetail.media;
          } else {
            return getImage(this.eventDetail);
          }
        }
        return null;
      }
    },
    selectedTags: {
      get () {
        return this.eventDetail && this.eventDetail.tags ? this.eventDetail.tags.map(item => { return { id: item.id, title: item.title } }) : [];
      },
      set (val) {
        const event = {...this.eventDetail};
        event.tags = val;
        this.$store.commit(SET_EVENT_DETAIL, event);
      },
    },
    addressType: {
      get() {
        return this.eventDetail && this.eventDetail.addressType;
      },
      set(val) {
        const event = {...this.eventDetail};
        event.addressType = val;
        this.$store.commit(SET_EVENT_DETAIL, event);
      }
    },
    detailed_location: {
      get() {
        return this.eventDetail ?this.eventDetail.detailed_location :null;
      },
      set(val) {
        const event = {...this.eventDetail};
        event.detailed_location = val;
        this.$store.commit(SET_EVENT_DETAIL, event);
      }
    },
    ...mapGetters(['tags', 'communities', 'eventStatus', 'eventDetail'])
  },
  mounted() {
    this.init();
    this.selectedTagsCache = [];
  },
  methods: {
    getImage,
    getPrefectures,
    loadImage(event) {
      const input = event.target;
      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.$store.commit(UPDATE_EVENT_PICTURE, e.target.result);
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    init() {
      this.$store.dispatch(TAG_REQUEST);
      this.$store.dispatch(COMMUNITY_REQUEST);
      this.$store.dispatch(EVENT_DETAIL, this.$route.params.id);
    },
    onSubmit(published) {
      let form = this.$refs["uploadForm"];
      let formData = new FormData();
      let formElements = form.elements;
      const { canvas } = this.$refs.cropper.getResult();
      let data = {};
      for (let i = 0; i < formElements.length; i++) {
        const currentElement = formElements[i];
        if (!['submit', 'file'].includes(currentElement.type)) {
          data[currentElement.name] = currentElement.value;
          if (currentElement.multiple) {
            data[currentElement.name] = [...currentElement.options].filter(option => option.selected).map(option => option.value);
          }
        }
      }
      data.dateTime = `${data.date}T${data.time}+0900`
      data.token = localStorage.getItem('user-token');
      data.mapUrl = this.mapUrl;
      data.address = this.address;
      data.published = this.published;
      data.detailed_location = null;

      if (this.address) {
        data.detailed_location = this.detailed_location;
        // save city to the 'location' field from google location API
        data.location = this.cityFromPostalCode;
      }
      else {
        // save prefecture and free text to the 'location field' if google API is not used
        data.location = `【${this.eventDetail.prefecture}】${this.eventDetail.locationFreeText}`;
      }
      data.tags = this.selectedTags.map(item => item.id);
      if (published) {
        data.published = published;
      }
      formData.append("data", JSON.stringify(data));

      if (!canvas) {
        alert('画像を選択してください');
        return;
      }
      canvas.toBlob(blob => {
        formData.append('files.media', blob);
        this.$store.dispatch(EVENT_EDIT, {formData, id: this.$route.params.id})
          .then(() => {
            this.$router.push({ name: 'events' });
          })
      });
    },
    cropperReady() {
      const { width, height } = this.eventDetail.media;
      this.$refs.cropper.setCoordinates({
        width,
        height,
      })
    },
    submitForm(published) {
      if (this.$refs.uploadForm.checkValidity()) {
        this.onSubmit(published);
      } else {
        this.$refs.uploadForm.reportValidity();
      }
    }
  }
}
</script>
